import s from './OokaBetterSharedGroup.module.scss'
import { ReactElement } from 'react'
import cn from 'classnames'
import Slider, { Settings as ReactSlickSettings } from 'react-slick'
import { useIsArabic } from '@components/common/IsArabic/useIsArabic'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
}

const simplicityLandingSliderSettings = {
    centerMode: true,
    centerPadding: '20%',
    slidesToShow: 3,
    speed: 3000,
    autoplaySpeed: 0,
    infinite: true,
    autoplay: true,
    accessibility: false,
    cssEase: 'linear',
    rtl: false,
    arrows: false,
    dots: false,
    pauseOnFocus: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                centerPadding: '15%'
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                centerPadding: '20%'
            }
        }
    ]
} as ReactSlickSettings
const OokaBetterSharedGroup = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: {
            heading,
            'instagram-url': instagramUrl,
            'x-url': xUrl,
            'youtube-url': youtubeUrl,
            'background-color': backgroundColor,
            'heading-color': headingColor
        },
        children
    } = props
    const enhancedChildren = children?.map((item) => {
        item.props.data.childLength = children?.length
        return item
    })
    const isArabic = useIsArabic()

    return (
        <div
            className={s.OkkaBetterGroup}
            style={
                { '--background-color': backgroundColor } as React.CSSProperties
            }
        >
            <h2
                style={{ '--text-color': headingColor } as React.CSSProperties}
                className={s['section-title']}
            >
                {heading}
            </h2>
            <div className={s['social-links']}>
                {instagramUrl && (
                    <a
                        href={instagramUrl}
                        target="_blank"
                        className={cn(s['social-section-link'], s['instagram'])}
                        rel="noreferrer"
                    >
                        {/*eslint-disable-next-line i18next/no-literal-string*/}
                        <img src="/icons/instagram.svg" alt="Instagram" />
                    </a>
                )}
                {youtubeUrl && (
                    <a
                        href={youtubeUrl}
                        target="_blank"
                        className={cn(s['social-section-link'], s['youtube'])}
                        rel="noreferrer"
                    >
                        {/*eslint-disable-next-line i18next/no-literal-string*/}
                        <img src="/icons/youtube.svg" alt="Youtube" />
                    </a>
                )}
                {xUrl && (
                    <a
                        href={xUrl}
                        target="_blank"
                        className={cn(s['social-section-link'], s['twitter'])}
                        rel="noreferrer"
                    >
                        {/*eslint-disable-next-line i18next/no-literal-string*/}
                        <img src="/icons/twitter.svg" alt="Twitter" />
                    </a>
                )}
            </div>
            <div className={s['slider-wrapper']}>
                <Slider {...simplicityLandingSliderSettings} rtl={isArabic}>
                    {enhancedChildren}
                </Slider>
            </div>
        </div>
    )
}
export default OokaBetterSharedGroup
